import { render, staticRenderFns } from "./HomeArticle.vue?vue&type=template&id=340d1ef6&"
import script from "./HomeArticle.vue?vue&type=script&lang=ts&"
export * from "./HomeArticle.vue?vue&type=script&lang=ts&"
import style0 from "./HomeArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports